/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable react/no-array-index-key */
import _ from 'lodash';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../components/Buttons';
import { selectWork } from '../../Api/selectors';
import { silverdatGet } from '../actions';
import { REQUEST_SILVERDAT_GET } from '../constants';
import { Loader } from '../../../components/Loader';
import { HBox, VBox } from '../../../components/Box';
import { Cell, List, Row } from '../../../components/List';
import Inspector from 'react-inspector';
import { COLOR_PRIMARY_1 } from '../../../vars';
import { Well } from '../../../components/Well';
import { selectSilverdatData } from '../selectors';

const Container = styled.div`
  h2 {
    font-size: 24px;
    color: ${COLOR_PRIMARY_1};
    margin-top: 24px;
  }
  .pair {
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 5px;
    border-bottom: 1px solid #ddd;

    > :first-child {
      font-weight: 600;
    }
    &.one {
      > :first-child {
        width: 180px;
        max-width: 180px;
        min-width: 180px;
      }
    }

    &.two {
      > :first-child {
        width: 80px;
        max-width: 80px;
        min-width: 80px;
      }
    }

    &.three {
      > :first-child {
        width: 30px;
        max-width: 30px;
        min-width: 30px;
      }
      > :nth-child(2) {
        width: 50px;
        max-width: 50px;
        min-width: 50px;
      }
    }

    &.four {
      > :first-child {
        width: 70px;
        max-width: 70px;
        min-width: 70px;
      }
      > :nth-child(2) {
        width: 200px;
        max-width: 200px;
        min-width: 200px;
      }
    }
    &.five {
      > :first-child {
        width: 400px;
        max-width: 400px;
        min-width: 400px;
      }
      > :nth-child(2) {
        width: 70px;
        max-width: 70px;
        min-width: 70px;
      }
    }
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class VehicleSilverdatComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE, _result: tmp.data.payload });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  getResult() {
    if (!this.result || this.result.error) return null;

    let vehicle = Object.keys(this.result.Vehicle)?.map(key => ({
      name: key,
      value: this.result.Vehicle?.[key]?.Value,
    }));

    let DATECodeEquipment = this.result.Vehicle?.DATECodeEquipment?.EquipmentPosition?.map(pair => ({
      id: pair.DatEquipmentId?.Value,
      description: pair.Description?.Value,
    }));

    let VINColors = this.result.Vehicle?.VINResult?.VINColors?.VINColor?.map(color => ({
      id: color.ColorID?.Value,
      code: color.Code?.Value,
      description: color.Description?.Value,
    }));

    let SeriesEquipment = this.result.Vehicle?.Equipment?.SeriesEquipment?.EquipmentPosition?.map(pair => ({
      id: pair.DatEquipmentId?.Value,
      manufacturerEquipmentId: pair.ManufacturerEquipmentId?.Value,
      description: pair.Description?.Value,
    }));

    let SpecialEquipment = this.result.Vehicle?.Equipment?.SpecialEquipment?.EquipmentPosition?.map(pair => ({
      id: pair.DatEquipmentId?.Value,
      manufacturerCode: pair.ManufacturerCode?.Value,
      description: pair.Description?.Value,
    }));

    let VINEquipments = this.result.Vehicle?.VINResult?.VINEquipments?.VINEquipment?.map(pair => ({
      avNumberDat: pair.AvNumberDat?.Value,
      shortName: pair.ShortName?.Value,
      manufacturerCode: pair.ManufacturerCode?.Value,
    }));

    return {
      vehicle,
      DATECodeEquipment,
      VINColors,
      SeriesEquipment,
      SpecialEquipment,
      VINEquipments,
    };
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get entityId() {
    return this.vehicle?.id;
  }

  get entityType() {
    return 'vehicle';
  }

  onResult(result) {
    //this.setState({ result });
  }

  get result() {
    if (this.props.silverdatResultData) {
      return this.props.silverdatResultData;
    }

    if (this.vehicle?.silverdat_response) {
      let data;
      try {
        data = JSON.parse(this.vehicle.silverdat_response);
      } catch (e) {
        console.log(e);
      }
      return data;
    }

    return null;
  }

  create() {}

  render() {
    if (this.props.loading) return <Loader small />;

    return (
      <Container>
        <VBox gap={14}>
          <Button
            disabled={this.vehicle?.silverdat_response && !this.result?.error}
            onClick={() => this.props.fetch(this.onResult.bind(this))}
          >
            {this.lbl('vehicle.details.silverdat.get')}
          </Button>
          {this.renderResult()}
        </VBox>
      </Container>
    );
  }

  renderResult() {
    if (this.result?.error) {
      if (this.result.error?.toLowerCase() === 'ecode is niet gevanden in dat database') {
        return <Well alert>{this.lbl('vehicle.details.silverdat.noDataError')}</Well>;
      }
      return <Well alert>{this.result.error}</Well>;
    }

    const r = this.getResult();
    if (!r) return null;

    return (
      <>
        <HBox gap={12}>
          <VBox>
            <h2>Silderdat VIN-informatie </h2>
            {r?.vehicle?.map(pair => (
              <div className="pair one" key={pair.name}>
                <div>{pair.name}</div>
                <div>{pair.value}</div>
              </div>
            ))}
            <h2>DAT ECode uitrustinglijst </h2>
            {r?.DATECodeEquipment?.map(pair => (
              <div className="pair two" key={pair.name}>
                <div>{pair.id}</div>
                <div>{pair.description}</div>
              </div>
            ))}
            <h2>Beschikbare kleuren</h2>
            {r?.VINColors?.map(pair => (
              <div className="pair three" key={pair.name}>
                <div>{pair.id}</div>
                <div>{pair.code}</div>
                <div>{pair.description}</div>
              </div>
            ))}
          </VBox>
          <VBox>
            <h2>Standaard uitrustinglijst </h2>
            {r?.SeriesEquipment?.map(pair => (
              <div className="pair four" key={pair.name}>
                <div>{pair.id}</div>
                <div>{pair.description}</div>
                <div>{pair.manufacturerEquipmentId}</div>
              </div>
            ))}

            <h2>VIN-Equipments</h2>
            {r?.VINEquipments?.map(pair => (
              <div className="pair five" key={pair.name}>
                <div>{pair.shortName}</div>
                <div>{pair.manufacturerCode}</div>
                <div>{pair.avNumberDat}</div>
              </div>
            ))}
          </VBox>
          <VBox>
            <h2>Uitrusting optioneel</h2>
            {r?.SpecialEquipment?.map(pair => (
              <div className="pair four" key={pair.name}>
                <div>{pair.id}</div>
                <div>{pair.description}</div>
                <div>{pair.manufacturerEquipmentId}</div>
              </div>
            ))}
          </VBox>
        </HBox>

        {/* <Inspector data={this.result.Vehicle} expandLevel={40}></Inspector> */}
      </>
    );
  }
}

VehicleSilverdatComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWork(REQUEST_SILVERDAT_GET),
    silverdatResultData: selectSilverdatData(ownProps.vehicle.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(callback) {
      dispatch(silverdatGet(ownProps.vehicle.id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleSilverdat = compose(withConnect, withRouter)(VehicleSilverdatComp);

const tmp = {
  success: true,
  message: 'OK',
  errors: null,
  data: {
    payload: {
      Country: {
        Value: 'NL',
      },
      Language: {
        Value: 'nl_NL',
      },
      Vehicle: {
        DatECode: {
          Value: '015700699530007',
        },
        Container: {
          Value: 'NL009',
        },
        ConstructionTime: {
          Value: '6106',
        },
        ConstructionTimeFrom: {
          Value: '6079',
        },
        ConstructionTimeTo: {
          Value: '6369',
        },
        ManufacturerName: {
          origin: 'dat',
          Value: 'Mercedes-Benz',
        },
        SalesDescription: {
          Value: 'GLC 300 e AMG Line 4Matic (EURO 6d)',
        },
        VehicleTypeName: {
          Value: 'Personenv., SUV, bestelauto',
        },
        BaseModelName: {
          origin: 'dat',
          Value: 'GLC -klasse (X253)(06.2015->)',
        },
        SubModelName: {
          origin: 'dat',
          Value: 'GLC 300 e 4Matic (253.953)',
        },
        ContainerName: {
          Value: 'NL - SUV5 GLC 300 e EU6d, e AMG Line 4Matic (EURO 6d), (Facelift) 2020 - 2022',
        },
        VehicleType: {
          Value: '1',
        },
        Manufacturer: {
          Value: '570',
        },
        BaseModel: {
          Value: '69',
        },
        SubModel: {
          Value: '953',
        },
        IdentificationSource: 'IDENTIFICATIONSOURCE_VIN',
        ReleaseIndicator: 'ALL',
        Equipment: {
          SeriesEquipment: {
            EquipmentPosition: [
              {
                DatEquipmentId: {
                  Value: '70420',
                },
                Description: {
                  Value: 'Aandrijvingstype: Vierwielaandrijving',
                },
                EquipmentGroup: {
                  Value: '4WD',
                },
                EquipmentClass: {
                  Value: '4',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '39011',
                },
                Description: {
                  Value: 'Aansluiting (12V-aansluiting)',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '33508',
                },
                Description: {
                  Value: 'Achterbankleuning gedeeld / neerklapbaar',
                },
                EquipmentGroup: {
                  Value: 'SITH',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '18802',
                },
                Description: {
                  Value: 'Achterlichten LED',
                },
                EquipmentGroup: {
                  Value: 'LEDH',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '10715',
                },
                ManufacturerEquipmentId: {
                  Value: 'U60',
                },
                Description: {
                  Value: 'Actieve motorkap',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '18899',
                },
                ManufacturerEquipmentId: {
                  Value: 'K11',
                },
                Description: {
                  Value: 'Adaptief Remlicht',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '35503',
                },
                Description: {
                  Value: 'Afstandsontgrendeling Achterklep',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '26803',
                },
                Description: {
                  Value: 'Airbag Bestuurders-/passagierskant',
                },
                EquipmentGroup: {
                  Value: 'AIR1',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '26910',
                },
                ManufacturerEquipmentId: {
                  Value: 'U10',
                },
                Description: {
                  Value: 'Airbag Passagierszijde uitschakelbaar',
                },
                EquipmentGroup: {
                  Value: 'AIR1',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '38937',
                },
                ManufacturerEquipmentId: {
                  Value: 'B53',
                },
                Description: {
                  Value: 'Akoestische omgevingsbescherming (buitengeluid)',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '40000',
                },
                Description: {
                  Value: 'Antiblokkeersysteem (ABS)',
                },
                EquipmentGroup: {
                  Value: 'ABS',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '24133',
                },
                Description: {
                  Value: 'Audiosysteem Audio 20 (USB, GPS)',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '28802',
                },
                ManufacturerEquipmentId: {
                  Value: '580',
                },
                Description: {
                  Value: 'Automatische airconditioning (Thermatic 2 zones)',
                },
                EquipmentGroup: {
                  Value: 'KLI2',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '75945',
                },
                ManufacturerEquipmentId: {
                  Value: '421',
                },
                Description: {
                  Value: 'Automatische transmissie - (9-traps)',
                },
                EquipmentGroup: {
                  Value: 'AG',
                },
                EquipmentClass: {
                  Value: '11',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '27400',
                },
                ManufacturerEquipmentId: {
                  Value: '723',
                },
                Description: {
                  Value: 'Bagageruimteafdekking / Verduistering',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '25903',
                },
                ManufacturerEquipmentId: {
                  Value: '475',
                },
                Description: {
                  Value: 'Bandenspanningscontrolesysteem',
                },
                EquipmentGroup: {
                  Value: 'RDK',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '39003',
                },
                ManufacturerEquipmentId: {
                  Value: '309',
                },
                Description: {
                  Value: 'Bekerhouder voor',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '26850',
                },
                Description: {
                  Value: 'Bekkenairbag voor (Pelvisbag)',
                },
                EquipmentGroup: {
                  Value: 'AIR',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '3906',
                },
                ManufacturerEquipmentId: {
                  Value: '876',
                },
                Description: {
                  Value: 'Binnenverlichting-pakket',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '39403',
                },
                Description: {
                  Value: 'Brillenvak in Dakbekleding geïntegreerd',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '15201',
                },
                Description: {
                  Value: 'Buitenspiegel elektr. verstel- en verwarmbaar, beide',
                },
                EquipmentGroup: {
                  Value: 'AUSP',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '21300',
                },
                Description: {
                  Value: 'Bumper Wagenkleur',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '10005',
                },
                Description: {
                  Value: 'Carrosserie: 5-deurs',
                },
                EquipmentClass: {
                  Value: '2',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '35301',
                },
                Description: {
                  Value: 'Centrale vergrendeling met Afstandsbediening',
                },
                EquipmentGroup: {
                  Value: 'ZV',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '3300',
                },
                ManufacturerEquipmentId: {
                  Value: '900',
                },
                Description: {
                  Value: 'Chrome-pakket',
                },
                ContainedEquipmentPositions: {
                  EquipmentPosition: [
                    {
                      DatEquipmentId: {
                        Value: '12515',
                      },
                      Description: {
                        Value: 'Onderrijbeveiliging (Chroom)',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '16203',
                      },
                      Description: {
                        Value: 'Dakreling (Aluminium)',
                      },
                      EquipmentGroup: {
                        Value: 'DARE',
                      },
                      ContainedEquipmentPositions: null,
                    },
                  ],
                },
              },
              {
                DatEquipmentId: {
                  Value: '26708',
                },
                ManufacturerEquipmentId: {
                  Value: '440',
                },
                Description: {
                  Value: 'Cruisecontrol',
                },
                EquipmentGroup: {
                  Value: 'TEMP',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '24050',
                },
                ManufacturerEquipmentId: {
                  Value: '537',
                },
                Description: {
                  Value: 'DAB-Tuner (Radio-ontvangst digitaal)',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '2555',
                },
                ManufacturerEquipmentId: {
                  Value: 'P31',
                },
                Description: {
                  Value: 'Design- en uitrustingslijn AMG Line',
                },
                EquipmentClass: {
                  Value: '10',
                },
                ContainedEquipmentPositions: {
                  EquipmentPosition: [
                    {
                      DatEquipmentId: {
                        Value: '2215',
                      },
                      Description: {
                        Value: 'Styling-pakket (AMG / Exterieur)',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '4277',
                      },
                      Description: {
                        Value: 'AMG-Line Interieur',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '26207',
                      },
                      Description: {
                        Value: 'Interieurinrichting: Decoraties Aluminium',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '26601',
                      },
                      Description: {
                        Value: 'Edelstaalpedalen Sportdesign',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '28011',
                      },
                      Description: {
                        Value: 'Hemelbekleding zwart',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '28409',
                      },
                      Description: {
                        Value: 'Vloermatten AMG',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '30209',
                      },
                      Description: {
                        Value: 'Stoelbekleding/kussens: Leerimitatie Artico / Dinamica',
                      },
                      EquipmentGroup: {
                        Value: 'LED3',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '69012',
                      },
                      Description: {
                        Value: 'Stuur (Leer Nappa)',
                      },
                      EquipmentGroup: {
                        Value: 'LEN1',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '69103',
                      },
                      Description: {
                        Value: 'Stuur (Sport) met Multifunctie',
                      },
                      EquipmentGroup: {
                        Value: 'LEN5',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '49373',
                      },
                      Description: {
                        Value: 'Lichtmetalen velgen',
                      },
                      EquipmentGroup: {
                        Value: 'ALU',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '50301',
                      },
                      Description: {
                        Value: 'Lichtmetalen velgen',
                      },
                      EquipmentGroup: {
                        Value: 'ALU',
                      },
                      ContainedEquipmentPositions: null,
                    },
                  ],
                },
              },
              {
                DatEquipmentId: {
                  Value: '69820',
                },
                Description: {
                  Value: 'Directbesturing met variabele stuurbekrachtiging',
                },
                EquipmentGroup: {
                  Value: 'SL',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '79823',
                },
                Description: {
                  Value: 'Elektromotor 90 kW (Hybride aandrijving)',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '70308',
                },
                Description: {
                  Value: 'Elektron. stabiliteitsprogramma (ESP)',
                },
                EquipmentGroup: {
                  Value: 'ESP',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '77274',
                },
                ManufacturerEquipmentId: {
                  Value: 'B10',
                },
                Description: {
                  Value: 'Emissie-arm volgens emissienorm Euro 6d',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '40803',
                },
                Description: {
                  Value: 'Handrem elektrisch',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '26901',
                },
                Description: {
                  Value: 'Hoofdairbag-systeem (Windowbag)',
                },
                EquipmentGroup: {
                  Value: 'AIR4',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '96513',
                },
                Description: {
                  Value: 'Hybride 235 kW (Motor 2,0 L - 155 kW)',
                },
                EquipmentClass: {
                  Value: '1',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '25880',
                },
                Description: {
                  Value: 'Infotainment-systeem: Mercedes me connect',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '25879',
                },
                Description: {
                  Value: 'Infotainment-systeem: Remote Online',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '18604',
                },
                Description: {
                  Value: 'Inschakelautomaat voor Rijlicht',
                },
                EquipmentGroup: {
                  Value: 'AUFL',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '39308',
                },
                ManufacturerEquipmentId: {
                  Value: '8U8',
                },
                Description: {
                  Value: 'Isofix-houder voor Kinderzitje aan Achterbank',
                },
                EquipmentGroup: {
                  Value: 'KISI',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '35511',
                },
                ManufacturerEquipmentId: {
                  Value: '893',
                },
                Description: {
                  Value: 'Keyless Go Startsysteem',
                },
                EquipmentGroup: {
                  Value: 'KEYL',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '26701',
                },
                ManufacturerEquipmentId: {
                  Value: '294',
                },
                Description: {
                  Value: 'Knie-airbag Bestuurderskant',
                },
                EquipmentGroup: {
                  Value: 'AIR5',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '18207',
                },
                Description: {
                  Value: 'Knipperlicht in Buitenspiegel geïntegreerd',
                },
                EquipmentGroup: {
                  Value: 'AUSP',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '18582',
                },
                ManufacturerEquipmentId: {
                  Value: '632',
                },
                Description: {
                  Value: 'Koplamp LED High Performance',
                },
                EquipmentGroup: {
                  Value: 'LED',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '24858',
                },
                ManufacturerEquipmentId: {
                  Value: '351',
                },
                Description: {
                  Value: 'Mercedes-Benz Noodoproepsysteem',
                },
                EquipmentGroup: {
                  Value: 'FA10',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '256',
                },
                Description: {
                  Value: 'Modelwijziging met Code',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '4706',
                },
                ManufacturerEquipmentId: {
                  Value: '30P',
                },
                Description: {
                  Value: 'Opbergruimte-pakket',
                },
                ContainedEquipmentPositions: {
                  EquipmentPosition: [
                    {
                      DatEquipmentId: {
                        Value: '25084',
                      },
                      Description: {
                        Value: 'USB-aansluiting op de achterbank',
                      },
                      EquipmentGroup: {
                        Value: 'MP3A',
                      },
                      ContainedEquipmentPositions: null,
                    },
                  ],
                },
              },
              {
                DatEquipmentId: {
                  Value: '73225',
                },
                ManufacturerEquipmentId: {
                  Value: '76B',
                },
                Description: {
                  Value: 'Oplaadsysteem Wisselstroom (AC)',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '35003',
                },
                Description: {
                  Value: 'Raamopener elektrisch voor + achter',
                },
                EquipmentGroup: {
                  Value: 'FH4',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '40801',
                },
                Description: {
                  Value: 'Remassistent',
                },
                EquipmentGroup: {
                  Value: 'FA01',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '70521',
                },
                ManufacturerEquipmentId: {
                  Value: 'B59',
                },
                Description: {
                  Value: 'Rijassistent-systeem Agility Select / Dynamic Select (Rijmodusschakelaar)',
                },
                EquipmentGroup: {
                  Value: 'FA22',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '42926',
                },
                Description: {
                  Value: 'Rijassistent-systeem Attention-Assist (Vermoeidheidsdetectiesensor)',
                },
                EquipmentGroup: {
                  Value: 'FA41',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '40956',
                },
                ManufacturerEquipmentId: {
                  Value: '258',
                },
                Description: {
                  Value: 'Rijassistent-systeem Botsingwaarschuwingssysteem met Remfunctie (Collision Prevention Assist)',
                },
                EquipmentGroup: {
                  Value: 'ASTW',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '70603',
                },
                Description: {
                  Value: 'Rijassistent-systeem Hill-start',
                },
                EquipmentGroup: {
                  Value: 'FA16',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '24995',
                },
                ManufacturerEquipmentId: {
                  Value: '367',
                },
                Description: {
                  Value: 'Rijassistent-systeem Verkeersinformatiesysteem Live Traffic',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '25405',
                },
                Description: {
                  Value: 'Ritcomputer',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '19101',
                },
                ManufacturerEquipmentId: {
                  Value: '345',
                },
                Description: {
                  Value: 'Ruitenwisser met Regensensor',
                },
                EquipmentGroup: {
                  Value: 'SWRE',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '24792',
                },
                ManufacturerEquipmentId: {
                  Value: '355',
                },
                Description: {
                  Value: 'Spraaksturingssysteem Uitgebreide functies (MBUX)',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '32605',
                },
                Description: {
                  Value: 'Stoel voor links electr. verstelbaar',
                },
                EquipmentGroup: {
                  Value: 'SITE',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '32606',
                },
                Description: {
                  Value: 'Stoel voor rechts electr. verstelbaar',
                },
                EquipmentGroup: {
                  Value: 'SITE',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '69700',
                },
                Description: {
                  Value: 'Stuur met Wipschakelaars/knoppen',
                },
                EquipmentGroup: {
                  Value: 'LEN8',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '25512',
                },
                ManufacturerEquipmentId: {
                  Value: '446',
                },
                Description: {
                  Value: 'Touchpad (Middenconsole)',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '42207',
                },
                ManufacturerEquipmentId: {
                  Value: '482',
                },
                Description: {
                  Value: 'Vering voor grote Bodemvrijheid (Off-Road Chassis)',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '28402',
                },
                Description: {
                  Value: 'Vloermatten Velours',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '25072',
                },
                Description: {
                  Value: 'Voertuig setup (Onlineservice / Apps)',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '38035',
                },
                Description: {
                  Value: 'Voertuig-monitoring (Voertuigtrackingsysteem)',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '37110',
                },
                ManufacturerEquipmentId: {
                  Value: 'U01',
                },
                Description: {
                  Value: 'Waarschuwingssysteem / Statusweergave voor Veiligheidsgordels op de achterbank',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '22300',
                },
                Description: {
                  Value: 'Warmtewerend glas',
                },
                EquipmentGroup: {
                  Value: 'WDG',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '38105',
                },
                Description: {
                  Value: 'Wegrijblokkering',
                },
                EquipmentGroup: {
                  Value: 'WFS',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '71620',
                },
                Description: {
                  Value: 'Wielbasis 2873 mm',
                },
                EquipmentClass: {
                  Value: '3',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '26903',
                },
                Description: {
                  Value: 'Zij-airbag (Sidebag) voor',
                },
                EquipmentGroup: {
                  Value: 'AIR3',
                },
                ContainedEquipmentPositions: null,
              },
            ],
          },
          DeselectedSeriesEquipment: null,
          SpecialModelEquipment: null,
          SpecialEquipment: {
            EquipmentPosition: [
              {
                DatEquipmentId: {
                  Value: '36100',
                },
                ManufacturerEquipmentId: {
                  Value: '890',
                },
                Description: {
                  Value: 'Achterklep met automatisch Open- en sluitsysteem',
                },
                OriginalPrice: {
                  Value: 450,
                },
                EquipmentGroup: {
                  Value: 'HKEL',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '68802',
                },
                ManufacturerEquipmentId: {
                  Value: 'B51',
                },
                Description: {
                  Value: 'Bandenreparatieset (Tirefit)',
                },
                OriginalPrice: {
                  Value: 50,
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '25889',
                },
                ManufacturerEquipmentId: {
                  Value: '38U',
                },
                Description: {
                  Value: 'Infotainment-systeem: Remote & Charging Services Plus',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '31726',
                },
                ManufacturerEquipmentId: {
                  Value: '#',
                },
                Description: {
                  Value: 'Interieurinrichting: Edelhout Es, zwart / Aluminium',
                },
                OriginalPrice: {
                  Value: 290,
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '73205',
                },
                ManufacturerEquipmentId: {
                  Value: 'B80',
                },
                Description: {
                  Value: 'Laadkabel met Beveiligingscontactstekker (8,0 m)',
                },
                OriginalPrice: {
                  Value: 70,
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '73216',
                },
                ManufacturerEquipmentId: {
                  Value: 'B83',
                },
                Description: {
                  Value: 'Laadkabel voor openbare laadpalen (8,0 m)',
                },
                OriginalPrice: {
                  Value: 30,
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '50118',
                },
                ManufacturerEquipmentId: {
                  Value: 'RZG',
                },
                Description: {
                  Value: 'Lichtmetalen velgen voor/achter: 8x19 / 9x19 (AMG, 5-dubbelspaaks, Zwart, glansgedraaid)',
                },
                OriginalPrice: {
                  Value: 300,
                },
                EquipmentGroup: {
                  Value: 'ALU',
                },
                ContainedEquipmentPositions: {
                  EquipmentPosition: [
                    {
                      DatEquipmentId: {
                        Value: '50301',
                      },
                      Description: {
                        Value: 'Lichtmetalen velgen',
                      },
                      EquipmentGroup: {
                        Value: 'ALU',
                      },
                      ContainedEquipmentPositions: null,
                    },
                  ],
                },
              },
              {
                DatEquipmentId: {
                  Value: '11000',
                },
                ManufacturerEquipmentId: {
                  Value: '896U',
                },
                Description: {
                  Value: 'Metallic-lak',
                },
                OriginalPrice: {
                  Value: 780,
                },
                EquipmentGroup: {
                  Value: 'SONL',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '2235',
                },
                ManufacturerEquipmentId: {
                  Value: 'P55',
                },
                Description: {
                  Value: 'Night-pakket',
                },
                OriginalPrice: {
                  Value: 700,
                },
                ContainedEquipmentPositions: {
                  EquipmentPosition: [
                    {
                      DatEquipmentId: {
                        Value: '12523',
                      },
                      Description: {
                        Value: 'Onderrijbeveiliging voor en achter (Zwart)',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '15813',
                      },
                      Description: {
                        Value: 'Buitenspiegel zwart gespoten',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '16195',
                      },
                      Description: {
                        Value: 'Dakreling zwart',
                      },
                      EquipmentGroup: {
                        Value: 'DARE',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '23103',
                      },
                      Description: {
                        Value: 'Zijruiten achter en Achterruit verduisterd',
                      },
                      EquipmentGroup: {
                        Value: 'SORO',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '49370',
                      },
                      Description: {
                        Value: 'Lichtmetalen velgen',
                      },
                      EquipmentGroup: {
                        Value: 'ALU',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '50301',
                      },
                      Description: {
                        Value: 'Lichtmetalen velgen',
                      },
                      EquipmentGroup: {
                        Value: 'ALU',
                      },
                      ContainedEquipmentPositions: null,
                    },
                  ],
                },
              },
              {
                DatEquipmentId: {
                  Value: '16712',
                },
                ManufacturerEquipmentId: {
                  Value: '413',
                },
                Description: {
                  Value: 'Panoramisch zonnedak',
                },
                OriginalPrice: {
                  Value: 1420,
                },
                EquipmentGroup: {
                  Value: 'SD2',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '4412',
                },
                ManufacturerEquipmentId: {
                  Value: 'D3P',
                },
                Description: {
                  Value: 'Parkeer-pakket High-End',
                },
                OriginalPrice: {
                  Value: 460,
                },
                ContainedEquipmentPositions: {
                  EquipmentPosition: [
                    {
                      DatEquipmentId: {
                        Value: '3535',
                      },
                      Description: {
                        Value: 'Parkeer-pakket met 360° Camera',
                      },
                      EquipmentGroup: {
                        Value: 'PDC4',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '25791',
                      },
                      Description: {
                        Value: 'Rijassistent-systeem actieve Parkeerhulp',
                      },
                      EquipmentGroup: {
                        Value: 'PDC4',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '39816',
                      },
                      Description: {
                        Value: 'Camerasysteem 360 Graden',
                      },
                      EquipmentGroup: {
                        Value: 'FA26',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '4423',
                      },
                      Description: {
                        Value: 'Parkeer-pakket met Sensoren',
                      },
                      EquipmentGroup: {
                        Value: 'PDC1',
                      },
                      ContainedEquipmentPositions: null,
                    },
                  ],
                },
              },
              {
                DatEquipmentId: {
                  Value: '2453',
                },
                ManufacturerEquipmentId: {
                  Value: 'DAP',
                },
                Description: {
                  Value: 'Public-Charging-Paket',
                },
                OriginalPrice: {
                  Value: 330,
                },
                ContainedEquipmentPositions: {
                  EquipmentPosition: [
                    {
                      DatEquipmentId: {
                        Value: '73198',
                      },
                      Description: {
                        Value: 'Voorbereiding Mercedes me Charge',
                      },
                      ContainedEquipmentPositions: null,
                    },
                  ],
                },
              },
              {
                DatEquipmentId: {
                  Value: '40199',
                },
                ManufacturerEquipmentId: {
                  Value: 'U29',
                },
                Description: {
                  Value: 'Remsysteem met grote Remschijven (High-performance remsysteem)',
                },
                EquipmentGroup: {
                  Value: 'BREK',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '24205',
                },
                ManufacturerEquipmentId: {
                  Value: '853',
                },
                Description: {
                  Value: 'Sound-systeem',
                },
                OriginalPrice: {
                  Value: 350,
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '2610',
                },
                ManufacturerEquipmentId: {
                  Value: 'P49',
                },
                Description: {
                  Value: 'Spiegelpakket',
                },
                OriginalPrice: {
                  Value: 450,
                },
                ContainedEquipmentPositions: {
                  EquipmentPosition: [
                    {
                      DatEquipmentId: {
                        Value: '15002',
                      },
                      Description: {
                        Value: 'Buitenspiegel electr. inklapbaar',
                      },
                      EquipmentGroup: {
                        Value: 'AUSP',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '15801',
                      },
                      Description: {
                        Value: 'Buiten-/binnenspiegel met Dimautomaat',
                      },
                      EquipmentGroup: {
                        Value: 'AUSP',
                      },
                      ContainedEquipmentPositions: null,
                    },
                  ],
                },
              },
              {
                DatEquipmentId: {
                  Value: '14204',
                },
                ManufacturerEquipmentId: {
                  Value: '550',
                },
                Description: {
                  Value: 'Trekhaak (kogelkop zwenkbaar)',
                },
                OriginalPrice: {
                  Value: 960,
                },
                EquipmentGroup: {
                  Value: 'AHK',
                },
                ContainedEquipmentPositions: null,
              },
              {
                DatEquipmentId: {
                  Value: '2707',
                },
                ManufacturerEquipmentId: {
                  Value: 'DB2',
                },
                Description: {
                  Value: 'Uitrustingspakket: Business',
                },
                OriginalPrice: {
                  Value: 2600,
                },
                ContainedEquipmentPositions: {
                  EquipmentPosition: [
                    {
                      DatEquipmentId: {
                        Value: '1506',
                      },
                      Description: {
                        Value: 'Comfort-pakket',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '3109',
                      },
                      Description: {
                        Value: 'Seat-comfort-pakket',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '33305',
                      },
                      Description: {
                        Value: 'Lendensteun voor',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '29500',
                      },
                      Description: {
                        Value: 'Stoelverwarming voor',
                      },
                      EquipmentGroup: {
                        Value: 'SITB',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '3844',
                      },
                      Description: {
                        Value: 'Infotainment-pakket Advanced',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '4148',
                      },
                      Description: {
                        Value: 'Connectiviteit-pakket',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '24846',
                      },
                      Description: {
                        Value: 'Smartphone geïntegreerd',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '25921',
                      },
                      Description: {
                        Value: 'Media-Display',
                      },
                      EquipmentGroup: {
                        Value: 'MONM',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '41161',
                      },
                      Description: {
                        Value: 'Rijassistent-systeem Verkeerstekenherkenning',
                      },
                      EquipmentGroup: {
                        Value: 'FA28',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '4423',
                      },
                      Description: {
                        Value: 'Parkeer-pakket met Sensoren',
                      },
                      EquipmentGroup: {
                        Value: 'PDC1',
                      },
                      ContainedEquipmentPositions: null,
                    },
                    {
                      DatEquipmentId: {
                        Value: '25791',
                      },
                      Description: {
                        Value: 'Rijassistent-systeem actieve Parkeerhulp',
                      },
                      EquipmentGroup: {
                        Value: 'PDC4',
                      },
                      ContainedEquipmentPositions: null,
                    },
                  ],
                },
              },
            ],
          },
          FreeSpecialEquipment: null,
          AdditionalEquipment: null,
          FlatRateEquipment: null,
          DenialCaseEquipment: null,
        },
        VinAccuracy: {
          Value: '0',
        },
        DATECodeEquipment: {
          EquipmentPosition: [
            {
              DatEquipmentId: {
                Value: '96513',
              },
              Description: {
                Value: 'Hybride 235 kW (Motor 2,0 L - 155 kW)',
              },
              EquipmentClass: {
                Value: '1',
              },
              ContainedEquipmentPositions: null,
            },
            {
              DatEquipmentId: {
                Value: '10005',
              },
              Description: {
                Value: 'Carrosserie: 5-deurs',
              },
              EquipmentClass: {
                Value: '2',
              },
              ContainedEquipmentPositions: null,
            },
            {
              DatEquipmentId: {
                Value: '71620',
              },
              Description: {
                Value: 'Wielbasis 2873 mm',
              },
              EquipmentClass: {
                Value: '3',
              },
              ContainedEquipmentPositions: null,
            },
            {
              DatEquipmentId: {
                Value: '70420',
              },
              Description: {
                Value: 'Aandrijvingstype: Vierwielaandrijving',
              },
              EquipmentClass: {
                Value: '4',
              },
              ContainedEquipmentPositions: null,
            },
            {
              DatEquipmentId: {
                Value: '2555',
              },
              Description: {
                Value: 'Design- en uitrustingslijn AMG Line',
              },
              EquipmentClass: {
                Value: '10',
              },
              ContainedEquipmentPositions: null,
            },
            {
              DatEquipmentId: {
                Value: '75945',
              },
              Description: {
                Value: 'Automatische transmissie - (9-traps)',
              },
              EquipmentClass: {
                Value: '11',
              },
              ContainedEquipmentPositions: null,
            },
          ],
        },
        VINResult: {
          VinInterfaceVersion: {
            Value: '2.5',
          },
          VINECodes: {
            VINECode: [
              {
                Sign: {
                  Value: '0',
                },
                ConstructionTimeMin: {
                  Value: '6103',
                },
                ConstructionTime: {
                  Value: '6106',
                },
                ConstructionTimeEdge: {
                  Value: '5950',
                },
                ConstructionTimeProd: {
                  Value: '6106',
                },
                VINContainers: {
                  VINContainer: [
                    {
                      Container: {
                        Value: '009',
                      },
                      VehicleTypeKey: {
                        Value: '8',
                      },
                      ManufacturerKey: {
                        Value: '570',
                      },
                      VehicleMainTypeKey: {
                        Value: '2431',
                      },
                      VehicleSubTypeKey: {
                        Value: '9',
                      },
                      VehicleConstructionTime: {
                        Value: '6106',
                      },
                    },
                  ],
                },
              },
            ],
          },
          VINEquipments: {
            VINEquipment: [
              {
                ShortName: {
                  Value: 'Model: Sports Tourer GLC 300 e 4MATIC',
                },
              },
              {
                ManufacturerCode: {
                  Value: '02B',
                },
                ShortName: {
                  Value: 'OWNERS MANUAL AND SERVICE RECORD - GERMAN',
                },
              },
              {
                ManufacturerCode: {
                  Value: '02J',
                },
                ShortName: {
                  Value: 'CONV. WORLD MANUFACTURER TO MERCEDES-BENZ AG (ASF)',
                },
              },
              {
                ManufacturerCode: {
                  Value: '085',
                },
                ShortName: {
                  Value: 'CONVERSION WORLD MANUFACTURER TO MERCEDES-BENZ AG',
                },
              },
              {
                ManufacturerCode: {
                  Value: '16U',
                },
                ShortName: {
                  Value: 'SMARTPHONE INTEGRATION CARPLAY',
                },
              },
              {
                ManufacturerCode: {
                  Value: '17U',
                },
                ShortName: {
                  Value: 'SMARTPHONE INTEGRATION GOOGLE AUTOMOTIVE LINK',
                },
              },
              {
                ManufacturerCode: {
                  Value: '19A',
                },
                ShortName: {
                  Value: 'GENERATION EHS',
                },
              },
              {
                ManufacturerCode: {
                  Value: '19V',
                },
                ShortName: {
                  Value: 'SPEED + - LOADINDEX 101V + 103V',
                },
              },
              {
                ManufacturerCode: {
                  Value: '1A9',
                },
                ShortName: {
                  Value: 'HYBRID',
                },
              },
              {
                ManufacturerCode: {
                  Value: '1B3',
                },
                ShortName: {
                  Value: 'COMMUNICATION MODULE VARIANT FOR ECE',
                },
              },
              {
                ManufacturerCode: {
                  Value: '229L',
                },
                ShortName: {
                  Value: 'DEUTSCHLAND',
                },
              },
              {
                ManufacturerCode: {
                  Value: '255B',
                },
                ShortName: {
                  Value: 'MB-MOBILO WITH DSB AND GGD',
                },
              },
              {
                ManufacturerCode: {
                  Value: '2A7',
                },
                ShortName: {
                  Value: 'WANDLERVARIANTE 8',
                },
              },
              {
                ManufacturerCode: {
                  Value: '2XXL',
                },
                ShortName: {
                  Value: 'BUNDESREPUBLIK DEUTSCHLAND',
                },
              },
              {
                ManufacturerCode: {
                  Value: '332B',
                },
                ShortName: {
                  Value: 'LANGUAGE INSTRUMENT CLUSTER/ HU - GERMAN',
                },
              },
              {
                ManufacturerCode: {
                  Value: '3U6',
                },
                ShortName: {
                  Value: 'HU COUNTRY-SET FOR ECE/ROW',
                },
              },
              {
                ManufacturerCode: {
                  Value: '4A7',
                },
                ShortName: {
                  Value: 'BESTUECKUNG SCHALTELEMENTE (VIER RAEDER)',
                },
              },
              {
                ManufacturerCode: {
                  Value: '502',
                },
                ShortName: {
                  Value: '3 YEARS OF MAP UPDATES FREE OF CHARGE',
                },
              },
              {
                ManufacturerCode: {
                  Value: '50A',
                },
                ShortName: {
                  Value: 'MOMENTENVERTEILUNG 45/55',
                },
              },
              {
                ManufacturerCode: {
                  Value: '5A3',
                },
                ShortName: {
                  Value: 'EL.HYDR.STEU.EINHEIT-HYBRID',
                },
              },
              {
                ManufacturerCode: {
                  Value: '5P6',
                },
                ShortName: {
                  Value: 'CONTROL CODE SALES',
                },
              },
              {
                ManufacturerCode: {
                  Value: '630A',
                },
                ShortName: {
                  Value: 'FABRIC / LEATHERETTE / MICROFIBER',
                },
              },
              {
                ManufacturerCode: {
                  Value: '6A2',
                },
                ShortName: {
                  Value: 'GELENKFLANSCH M. GW 110 / 3, 3-ARM X 110',
                },
              },
              {
                ManufacturerCode: {
                  Value: '6P5',
                },
                ShortName: {
                  Value: 'CONTROL CODE SALES',
                },
              },
              {
                ManufacturerCode: {
                  Value: '70B',
                },
                ShortName: {
                  Value: 'SAFETY VESTS - DRIVER',
                },
              },
              {
                ManufacturerCode: {
                  Value: '7A3',
                },
                ShortName: {
                  Value: 'PLUG IN',
                },
              },
              {
                ManufacturerCode: {
                  Value: '8B8',
                },
                ShortName: {
                  Value: 'REDUCTION OF ACTIVE PARKING ASSISTANT (UN R79)',
                },
              },
              {
                ManufacturerCode: {
                  Value: '8U6',
                },
                ShortName: {
                  Value: 'CONVERSION STEERING WHEEL OPER. ASSISTENT SYSTEMS',
                },
              },
              {
                ManufacturerCode: {
                  Value: '969',
                },
                ShortName: {
                  Value: 'COC-DOC EURO 5 WITH VEHICLE REGISTR. DOC PART2',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'A030',
                },
                ShortName: {
                  Value: 'OEL-OFFSETMENGE +300GR OEL',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'A104',
                },
                ShortName: {
                  Value: 'VERZAHNUNG GERAEUSCHOPTIMIERT',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'A208',
                },
                ShortName: {
                  Value: 'GEWELLTE LAMELLEN B08',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'DMW',
                },
                ShortName: {
                  Value: 'CONTROL CODE SALES',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'F253',
                },
                ShortName: {
                  Value: 'BAUREIHE 253',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'FX',
                },
                ShortName: {
                  Value: 'SPECIAL VERSION',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'G043',
                },
                ShortName: {
                  Value: 'GETRIEBECODE AUSFUEHRUNG 43',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'GA',
                },
                ShortName: {
                  Value: 'AUTOMATIC TRANSMISSION',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'GH',
                },
                ShortName: {
                  Value: 'HYBRID TRANSMISSION',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'HA',
                },
                ShortName: {
                  Value: 'REAR AXLE',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'JVG',
                },
                ShortName: {
                  Value: 'STEUERCODE WERK',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'JVO',
                },
                ShortName: {
                  Value: 'STEUERCODE WERK',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'JVX',
                },
                ShortName: {
                  Value: 'STEUERCODE WERK',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'JWA',
                },
                ShortName: {
                  Value: 'STEUERCODE WERK',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'K13',
                },
                ShortName: {
                  Value: 'STEUERCODE FUER SERVICEINTERVALL 25000 KM',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'K37',
                },
                ShortName: {
                  Value: 'DEACTIVATION LOCKING RESPONSE BY FANFARE',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'L',
                },
                ShortName: {
                  Value: 'L.H.D',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'PZB',
                },
                ShortName: {
                  Value: 'CONTROL CODE MARKETING',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'PZV',
                },
                ShortName: {
                  Value: 'CONTROL CODE SALES',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'R05',
                },
                ShortName: {
                  Value: 'ROLLING RESISTANCE OPTIMISED SUMMER TYRE',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'VIN10:1',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'VIN11:F',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'VL',
                },
                ShortName: {
                  Value: 'FRONT AXLE HALF SHAFT, LEFT',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'VR',
                },
                ShortName: {
                  Value: 'FRONT AXLE HALF SHAFT, RIGHT',
                },
              },
              {
                ManufacturerCode: {
                  Value: 'WHC:W1N',
                },
              },
              {
                AvNumberDat: {
                  Value: '281',
                },
                ManufacturerCode: {
                  Value: '801',
                },
                ShortName: {
                  Value: 'AEJ 20/1',
                },
              },
              {
                AvNumberDat: {
                  Value: '699',
                },
                ManufacturerCode: {
                  Value: 'K31',
                },
                ShortName: {
                  Value: 'SOUND REGULATION FOR ECE R51-3',
                },
              },
              {
                AvNumberDat: {
                  Value: '1316',
                },
                ManufacturerCode: {
                  Value: 'P47',
                },
                ShortName: {
                  Value: 'PARKING PACKAGE HIGH',
                },
              },
              {
                AvNumberDat: {
                  Value: '1506',
                },
                ManufacturerCode: {
                  Value: 'D1K',
                },
                ShortName: {
                  Value: 'STEUERCODE VERTRIEB',
                },
              },
              {
                AvNumberDat: {
                  Value: '2215',
                },
                ManufacturerCode: {
                  Value: '772',
                },
                ShortName: {
                  Value: 'AMG STYLING PACKAGE-FRONT SPOILER, SIDE SKIRT',
                },
              },
              {
                AvNumberDat: {
                  Value: '2235',
                },
                ManufacturerCode: {
                  Value: 'P55',
                },
                ShortName: {
                  Value: 'NIGHT PACKAGE',
                },
              },
              {
                AvNumberDat: {
                  Value: '2453',
                },
                ManufacturerCode: {
                  Value: 'DAP',
                },
                ShortName: {
                  Value: 'CONTROL CODE SALES',
                },
              },
              {
                AvNumberDat: {
                  Value: '2555',
                },
                ManufacturerCode: {
                  Value: 'P31',
                },
                ShortName: {
                  Value: 'AMG LINE EXTERIOR / AMG SPORT-PACKAGE EXTERIOR',
                },
              },
              {
                AvNumberDat: {
                  Value: '2610',
                },
                ManufacturerCode: {
                  Value: 'P49',
                },
                ShortName: {
                  Value: 'SPIEGEL PAKET',
                },
              },
              {
                AvNumberDat: {
                  Value: '2707',
                },
                ManufacturerCode: {
                  Value: 'DB2',
                },
                ShortName: {
                  Value: 'CONTROL CODE SALES',
                },
              },
              {
                AvNumberDat: {
                  Value: '3109',
                },
                ManufacturerCode: {
                  Value: 'P65',
                },
                ShortName: {
                  Value: 'ERGONOMIC PACKAGE',
                },
              },
              {
                AvNumberDat: {
                  Value: '3300',
                },
                ManufacturerCode: {
                  Value: '900',
                },
                ShortName: {
                  Value: 'CHROME-PACKAGE',
                },
              },
              {
                AvNumberDat: {
                  Value: '3535',
                },
                ManufacturerCode: {
                  Value: 'P47',
                },
                ShortName: {
                  Value: 'PARKING PACKAGE HIGH',
                },
              },
              {
                AvNumberDat: {
                  Value: '3844',
                },
                ManufacturerCode: {
                  Value: 'D2I',
                },
                ShortName: {
                  Value: 'CONTROL CODE SALES',
                },
              },
              {
                AvNumberDat: {
                  Value: '3906',
                },
                ManufacturerCode: {
                  Value: '876',
                },
                ShortName: {
                  Value: 'INTERIOR LIGHT ASSY.',
                },
              },
              {
                AvNumberDat: {
                  Value: '4148',
                },
                ManufacturerCode: {
                  Value: 'PBF',
                },
                ShortName: {
                  Value: 'CONNECTIVITY PACKAGE MID',
                },
              },
              {
                AvNumberDat: {
                  Value: '4277',
                },
                ManufacturerCode: {
                  Value: 'P29',
                },
                ShortName: {
                  Value: 'AMG SPORT PACKAGE INTERIOR',
                },
              },
              {
                AvNumberDat: {
                  Value: '4412',
                },
                ManufacturerCode: {
                  Value: 'D3P',
                },
                ShortName: {
                  Value: 'CONTROL CODE SALES',
                },
              },
              {
                AvNumberDat: {
                  Value: '4706',
                },
                ManufacturerCode: {
                  Value: '30P',
                },
                ShortName: {
                  Value: 'STORAGE PACKAGE',
                },
              },
              {
                AvNumberDat: {
                  Value: '10715',
                },
                ManufacturerCode: {
                  Value: 'U60',
                },
                ShortName: {
                  Value: 'PEDESTRIAN PROTECTION -  ACTIVE HOOD',
                },
              },
              {
                AvNumberDat: {
                  Value: '11000',
                },
                ManufacturerCode: {
                  Value: '896U',
                },
                ShortName: {
                  Value: 'BRILLANTBLUE METALLIC PAINT',
                },
              },
              {
                AvNumberDat: {
                  Value: '11186',
                },
                ManufacturerCode: {
                  Value: '998',
                },
                ShortName: {
                  Value: 'CONTROL-CODE CONVERSION WLTP AND RDE',
                },
              },
              {
                AvNumberDat: {
                  Value: '14204',
                },
                ManufacturerCode: {
                  Value: '550',
                },
                ShortName: {
                  Value: 'TRAILER HITCH',
                },
              },
              {
                AvNumberDat: {
                  Value: '14623',
                },
                ManufacturerCode: {
                  Value: '274',
                },
                ShortName: {
                  Value: 'TELEPHONE ANTENNA',
                },
              },
              {
                AvNumberDat: {
                  Value: '14708',
                },
                ManufacturerCode: {
                  Value: '270',
                },
                ShortName: {
                  Value: 'GPS ANTENNA',
                },
              },
              {
                AvNumberDat: {
                  Value: '15002',
                },
                ManufacturerCode: {
                  Value: '500',
                },
                ShortName: {
                  Value: 'OUTSIDE REAR VIEW MIRROR LH AND RH FOLDING',
                },
              },
              {
                AvNumberDat: {
                  Value: '15801',
                },
                ManufacturerCode: {
                  Value: '249',
                },
                ShortName: {
                  Value: 'INSIDE AND OUTSIDE MIRROR AUTOMATIC DIMMING',
                },
              },
              {
                AvNumberDat: {
                  Value: '16000',
                },
                ManufacturerCode: {
                  Value: '720',
                },
                ShortName: {
                  Value: 'ROOF RAIL',
                },
              },
              {
                AvNumberDat: {
                  Value: '16198',
                },
                ManufacturerCode: {
                  Value: '720',
                },
                ShortName: {
                  Value: 'ROOF RAIL',
                },
              },
              {
                AvNumberDat: {
                  Value: '16712',
                },
                ManufacturerCode: {
                  Value: '413',
                },
                ShortName: {
                  Value: 'PANORAMA-SCHIEBEDACH/-GLASDACH',
                },
              },
              {
                AvNumberDat: {
                  Value: '18582',
                },
                ManufacturerCode: {
                  Value: '632',
                },
                ShortName: {
                  Value: 'HEADLIGHT UNIT LED W. STATIC LIGHT SYSTEM RHT',
                },
              },
              {
                AvNumberDat: {
                  Value: '18899',
                },
                ManufacturerCode: {
                  Value: 'K11',
                },
                ShortName: {
                  Value: 'ADAPTIVE STOP LIGHT FLASHING',
                },
              },
              {
                AvNumberDat: {
                  Value: '19101',
                },
                ManufacturerCode: {
                  Value: '345',
                },
                ShortName: {
                  Value: 'RAIN SENSOR',
                },
              },
              {
                AvNumberDat: {
                  Value: '20200',
                },
                ManufacturerCode: {
                  Value: '776',
                },
                ShortName: {
                  Value: 'WHEEL ARCH WIDENING',
                },
              },
              {
                AvNumberDat: {
                  Value: '23103',
                },
                ManufacturerCode: {
                  Value: '840',
                },
                ShortName: {
                  Value: 'DARK-TINTED GLASS',
                },
              },
              {
                AvNumberDat: {
                  Value: '24050',
                },
                ManufacturerCode: {
                  Value: '537',
                },
                ShortName: {
                  Value: 'DIGITAL RADIO STANDARD DAB (DIGI. AUDIO BROADC.)',
                },
              },
              {
                AvNumberDat: {
                  Value: '24205',
                },
                ManufacturerCode: {
                  Value: '853',
                },
                ShortName: {
                  Value: 'SOUND SYSTEM MIDLINE',
                },
              },
              {
                AvNumberDat: {
                  Value: '24706',
                },
                ManufacturerCode: {
                  Value: '79B',
                },
                ShortName: {
                  Value: 'VORRUESTUNG DIGITALER RADIO-STANDARD DAB',
                },
              },
              {
                AvNumberDat: {
                  Value: '24792',
                },
                ManufacturerCode: {
                  Value: '355',
                },
                ShortName: {
                  Value: 'PREPARATION FOR NAVIGATION RETROFITTING',
                },
              },
              {
                AvNumberDat: {
                  Value: '24819',
                },
                ManufacturerCode: {
                  Value: '274',
                },
                ShortName: {
                  Value: 'TELEPHONE ANTENNA',
                },
              },
              {
                AvNumberDat: {
                  Value: '24846',
                },
                ManufacturerCode: {
                  Value: '14U',
                },
                ShortName: {
                  Value: 'SMARTPHONE INTEGRATION PACKAGE',
                },
              },
              {
                AvNumberDat: {
                  Value: '24858',
                },
                ManufacturerCode: {
                  Value: '351',
                },
                ShortName: {
                  Value: 'ECALL-EMERGENCY CALL SYSTEM (HERMES)',
                },
              },
              {
                AvNumberDat: {
                  Value: '24946',
                },
                ManufacturerCode: {
                  Value: '548',
                },
                ShortName: {
                  Value: 'CONNECT 20 MID (NTG6)',
                },
              },
              {
                AvNumberDat: {
                  Value: '24995',
                },
                ManufacturerCode: {
                  Value: '367',
                },
                ShortName: {
                  Value: 'LIVE TRAFFIC - CAPABILITY (HERMES)',
                },
              },
              {
                AvNumberDat: {
                  Value: '25082',
                },
                ManufacturerCode: {
                  Value: '362',
                },
                ShortName: {
                  Value: 'HERMES COMMUNICATION MODULE LTE',
                },
              },
              {
                AvNumberDat: {
                  Value: '25084',
                },
                ManufacturerCode: {
                  Value: 'U82',
                },
                ShortName: {
                  Value: 'USB CHARGE SOCKET IN REAR',
                },
              },
              {
                AvNumberDat: {
                  Value: '25095',
                },
                ManufacturerCode: {
                  Value: '355',
                },
                ShortName: {
                  Value: 'PREPARATION FOR NAVIGATION RETROFITTING',
                },
              },
              {
                AvNumberDat: {
                  Value: '25512',
                },
                ManufacturerCode: {
                  Value: '446',
                },
                ShortName: {
                  Value: 'TOUCHPAD ONLY',
                },
              },
              {
                AvNumberDat: {
                  Value: '25752',
                },
                ManufacturerCode: {
                  Value: '365',
                },
                ShortName: {
                  Value: 'FIXED DISK NAVIGATION',
                },
              },
              {
                AvNumberDat: {
                  Value: '25791',
                },
                ManufacturerCode: {
                  Value: '235',
                },
                ShortName: {
                  Value: 'ACTIVE PARKING ASSISTANCE',
                },
              },
              {
                AvNumberDat: {
                  Value: '25861',
                },
                ManufacturerCode: {
                  Value: '13U',
                },
                ShortName: {
                  Value: 'MBCONNECT - EV FEATURES  (HERMES)',
                },
              },
              {
                AvNumberDat: {
                  Value: '25883',
                },
                ManufacturerCode: {
                  Value: '01U',
                },
                ShortName: {
                  Value: 'MB-CONNECT-SERVICES FOR NAVIGATION',
                },
              },
              {
                AvNumberDat: {
                  Value: '25889',
                },
                ManufacturerCode: {
                  Value: '38U',
                },
                ShortName: {
                  Value: 'MBCONNECT CONNECTIVITY AND LOADING PLUS',
                },
              },
              {
                AvNumberDat: {
                  Value: '25903',
                },
                ManufacturerCode: {
                  Value: '475',
                },
                ShortName: {
                  Value: 'INFLATION PRESSURE CONTROL HIGH LINE/MID LINE',
                },
              },
              {
                AvNumberDat: {
                  Value: '25921',
                },
                ManufacturerCode: {
                  Value: '859',
                },
                ShortName: {
                  Value: 'CENTRAL DISPLAY MID (9" TILL 11,5" DIAGONAL)',
                },
              },
              {
                AvNumberDat: {
                  Value: '26207',
                },
                ManufacturerCode: {
                  Value: '739',
                },
                ShortName: {
                  Value: 'TRIM ELEMENTS - ALUMINIUM',
                },
              },
              {
                AvNumberDat: {
                  Value: '26701',
                },
                ManufacturerCode: {
                  Value: '294',
                },
                ShortName: {
                  Value: 'KNEEBAG',
                },
              },
              {
                AvNumberDat: {
                  Value: '26708',
                },
                ManufacturerCode: {
                  Value: '440',
                },
                ShortName: {
                  Value: 'TEMPOMAT',
                },
              },
              {
                AvNumberDat: {
                  Value: '26910',
                },
                ManufacturerCode: {
                  Value: 'U10',
                },
                ShortName: {
                  Value: 'FRONT-PASSENGER SEAT WITH WEIGHT DETECTION',
                },
              },
              {
                AvNumberDat: {
                  Value: '27079',
                },
                ManufacturerCode: {
                  Value: '737',
                },
                ShortName: {
                  Value: 'CENTER CONSOLE IN WOOD ASH BLACK OPEN CELL (2A70)',
                },
              },
              {
                AvNumberDat: {
                  Value: '27400',
                },
                ManufacturerCode: {
                  Value: '723',
                },
                ShortName: {
                  Value: 'BAGGAGE COMPARTMENT COVERING',
                },
              },
              {
                AvNumberDat: {
                  Value: '28011',
                },
                ManufacturerCode: {
                  Value: '51U',
                },
                ShortName: {
                  Value: 'HEADLINER FABRIC BLACK',
                },
              },
              {
                AvNumberDat: {
                  Value: '28409',
                },
                ManufacturerCode: {
                  Value: 'U26',
                },
                ShortName: {
                  Value: 'FLOOR MATS - AMG',
                },
              },
              {
                AvNumberDat: {
                  Value: '28802',
                },
                ManufacturerCode: {
                  Value: '580',
                },
                ShortName: {
                  Value: 'AIR CONDITIONING',
                },
              },
              {
                AvNumberDat: {
                  Value: '29099',
                },
                ManufacturerCode: {
                  Value: '2U8',
                },
                ShortName: {
                  Value: 'REFRIGERANT ALTERNATIVE',
                },
              },
              {
                AvNumberDat: {
                  Value: '29500',
                },
                ManufacturerCode: {
                  Value: '873',
                },
                ShortName: {
                  Value: 'SEAT HEATING FRONT SEATS LH AND RH',
                },
              },
              {
                AvNumberDat: {
                  Value: '30209',
                },
                ManufacturerCode: {
                  Value: '631A',
                },
                ShortName: {
                  Value: 'FABRIC / LEATHERETTE / MICROF - BLACK / ANTHRACITE',
                },
              },
              {
                AvNumberDat: {
                  Value: '31726',
                },
                ManufacturerCode: {
                  Value: '#',
                },
              },
              {
                AvNumberDat: {
                  Value: '33403',
                },
                ManufacturerCode: {
                  Value: 'U22',
                },
                ShortName: {
                  Value: 'LUMBAR BOLSTER ADJUSTMENT',
                },
              },
              {
                AvNumberDat: {
                  Value: '35511',
                },
                ManufacturerCode: {
                  Value: '893',
                },
                ShortName: {
                  Value: 'KEYLESS-START',
                },
              },
              {
                AvNumberDat: {
                  Value: '36100',
                },
                ManufacturerCode: {
                  Value: '890',
                },
                ShortName: {
                  Value: 'AUTOMATIC REAR DOOR',
                },
              },
              {
                AvNumberDat: {
                  Value: '37008',
                },
                ManufacturerCode: {
                  Value: '431',
                },
                ShortName: {
                  Value: 'GEARSHIFT ON STEERING WHEEL - GALVANIZED',
                },
              },
              {
                AvNumberDat: {
                  Value: '37028',
                },
                ManufacturerCode: {
                  Value: '8U7',
                },
                ShortName: {
                  Value: 'REAR SEAT BELT WITH BELT FORCE LIMITER A. SOFTSTOP',
                },
              },
              {
                AvNumberDat: {
                  Value: '37110',
                },
                ManufacturerCode: {
                  Value: 'U01',
                },
                ShortName: {
                  Value: 'REAR SEAT BELT STATUS SIGNAL',
                },
              },
              {
                AvNumberDat: {
                  Value: '37700',
                },
                ManufacturerCode: {
                  Value: '611',
                },
                ShortName: {
                  Value: 'SURROUND LIGHTING',
                },
              },
              {
                AvNumberDat: {
                  Value: '37809',
                },
                ManufacturerCode: {
                  Value: '249',
                },
                ShortName: {
                  Value: 'INSIDE AND OUTSIDE MIRROR AUTOMATIC DIMMING',
                },
              },
              {
                AvNumberDat: {
                  Value: '37901',
                },
                ManufacturerCode: {
                  Value: '249',
                },
                ShortName: {
                  Value: 'INSIDE AND OUTSIDE MIRROR AUTOMATIC DIMMING',
                },
              },
              {
                AvNumberDat: {
                  Value: '38937',
                },
                ManufacturerCode: {
                  Value: 'B53',
                },
                ShortName: {
                  Value: 'EXTERIOR NOISE -SOUND GENERATOR FOR HYBRID',
                },
              },
              {
                AvNumberDat: {
                  Value: '39003',
                },
                ManufacturerCode: {
                  Value: '309',
                },
                ShortName: {
                  Value: 'CUPHOLDER',
                },
              },
              {
                AvNumberDat: {
                  Value: '39007',
                },
                ManufacturerCode: {
                  Value: 'U35',
                },
                ShortName: {
                  Value: 'PLUG SOCKET 12 V IN LOADING COMPARTMENT',
                },
              },
              {
                AvNumberDat: {
                  Value: '39308',
                },
                ManufacturerCode: {
                  Value: '8U8',
                },
                ShortName: {
                  Value: 'I-SIZE-MARKING (ISOFIX-SUCCESSOR)',
                },
              },
              {
                AvNumberDat: {
                  Value: '39816',
                },
                ManufacturerCode: {
                  Value: '501',
                },
                ShortName: {
                  Value: 'SURROUND VIEW SYSTEM',
                },
              },
              {
                AvNumberDat: {
                  Value: '40199',
                },
                ManufacturerCode: {
                  Value: 'U29',
                },
                ShortName: {
                  Value: 'SPORT-BREMSANLAGE',
                },
              },
              {
                AvNumberDat: {
                  Value: '40956',
                },
                ManufacturerCode: {
                  Value: '258',
                },
                ShortName: {
                  Value: 'FORWARD COLLISION WARN.(FCW) W.ACTIVE BRAKE CONTR.',
                },
              },
              {
                AvNumberDat: {
                  Value: '41161',
                },
                ManufacturerCode: {
                  Value: '513',
                },
                ShortName: {
                  Value: 'TRAFFIC SIGN RECOGNITION',
                },
              },
              {
                AvNumberDat: {
                  Value: '42207',
                },
                ManufacturerCode: {
                  Value: '482',
                },
                ShortName: {
                  Value: 'SUSPENSION FOR GREATER GROUND CLEARANCE',
                },
              },
              {
                AvNumberDat: {
                  Value: '50118',
                },
                ManufacturerCode: {
                  Value: 'RZG',
                },
                ShortName: {
                  Value: 'AMG-DOPPELSPEICHENRAEDER 19" MIT MISCHBEREIFUNG',
                },
              },
              {
                AvNumberDat: {
                  Value: '68802',
                },
                ManufacturerCode: {
                  Value: 'B51',
                },
                ShortName: {
                  Value: 'TIREFIT',
                },
              },
              {
                AvNumberDat: {
                  Value: '69012',
                },
                ManufacturerCode: {
                  Value: 'L5C',
                },
                ShortName: {
                  Value: 'SUPERSPORT STEERING WHEEL - LEATHER EMBOSSED',
                },
              },
              {
                AvNumberDat: {
                  Value: '70521',
                },
                ManufacturerCode: {
                  Value: 'B59',
                },
                ShortName: {
                  Value: 'DRIVING EXPERIENCE SWITCH(INDIVIDUAL DRIVING PROG)',
                },
              },
              {
                AvNumberDat: {
                  Value: '73205',
                },
                ManufacturerCode: {
                  Value: 'B80',
                },
                ShortName: {
                  Value: 'CHARGING CABLE SCHUKO CEE 7/7 (TYPE E/F) 8M',
                },
              },
              {
                AvNumberDat: {
                  Value: '73216',
                },
                ManufacturerCode: {
                  Value: 'B83',
                },
                ShortName: {
                  Value: 'CHARGING CABLE 7-PIN ICCA PER IEC 62196 16A 8M',
                },
              },
              {
                AvNumberDat: {
                  Value: '73225',
                },
                ManufacturerCode: {
                  Value: '76B',
                },
                ShortName: {
                  Value: 'AC CHARGING FUNCTION WITH 7,4 KW CHARGING POWER',
                },
              },
              {
                AvNumberDat: {
                  Value: '73256',
                },
                ManufacturerCode: {
                  Value: '63B',
                },
                ShortName: {
                  Value: 'VEHICLE. XEV-CHARGING BOX COMBO2 / TYPE2',
                },
              },
              {
                AvNumberDat: {
                  Value: '75945',
                },
                ManufacturerCode: {
                  Value: '421',
                },
                ShortName: {
                  Value: 'AUTOMATIC TRANSMISSION 9-SPEED',
                },
              },
              {
                AvNumberDat: {
                  Value: '77227',
                },
                ManufacturerCode: {
                  Value: '927',
                },
                ShortName: {
                  Value: 'EMISSION CONTROL EURO 6 TECHNIQUE',
                },
              },
              {
                AvNumberDat: {
                  Value: '77274',
                },
                ManufacturerCode: {
                  Value: 'B10',
                },
                ShortName: {
                  Value: 'FUEL TANK SYSTEM FOR EU6D-NORM',
                },
              },
              {
                AvNumberDat: {
                  Value: '77374',
                },
                ManufacturerCode: {
                  Value: 'B10',
                },
                ShortName: {
                  Value: 'FUEL TANK SYSTEM FOR EU6D-NORM',
                },
              },
              {
                AvNumberDat: {
                  Value: '77650',
                },
                ManufacturerCode: {
                  Value: '961',
                },
                ShortName: {
                  Value: 'EXHAUST SYSTEM WITH OPF GENERATION 2.0',
                },
              },
              {
                AvNumberDat: {
                  Value: '96133',
                },
                ManufacturerCode: {
                  Value: 'M20',
                },
                ShortName: {
                  Value: 'DISPLACEMENT 2.0 LITER',
                },
              },
              {
                AvNumberDat: {
                  Value: '96155',
                },
                ManufacturerCode: {
                  Value: 'M274',
                },
                ShortName: {
                  Value: 'R4-GASOLINE ENGINE M274',
                },
              },
              {
                AvNumberDat: {
                  Value: '96180',
                },
                ManufacturerCode: {
                  Value: 'M005',
                },
                ShortName: {
                  Value: 'CHASSIS WITH 4-MATIC-/ALL-WHEEL DRIVE',
                },
              },
              {
                AvNumberDat: {
                  Value: '96181',
                },
                ManufacturerCode: {
                  Value: 'M006',
                },
                ShortName: {
                  Value: 'POWER OUTPUT VARIANT',
                },
              },
              {
                AvNumberDat: {
                  Value: '96191',
                },
                ManufacturerCode: {
                  Value: 'ME05',
                },
                ShortName: {
                  Value: 'HYBRID DRIVE 85KW-/90KW - VERSION (INCL. PLUGIN)',
                },
              },
              {
                AvNumberDat: {
                  Value: '99954',
                },
                ManufacturerCode: {
                  Value: 'COUNTRY:DE',
                },
              },
            ],
          },
          VINColors: {
            VINColor: [
              {
                ColorID: {
                  Value: 'A1',
                },
                Code: {
                  Value: '896',
                },
              },
              {
                ColorID: {
                  Value: 'I1',
                },
                Code: {
                  Value: '631',
                },
                Description: {
                  Value: 'FABRIC / LEATHERETTE / MICROF - BLACK / ANTHRACITE',
                },
              },
              {
                ColorID: {
                  Value: 'I2',
                },
                Code: {
                  Value: '630',
                },
                Description: {
                  Value: 'FABRIC / LEATHERETTE / MICROFIBER',
                },
              },
            ],
          },
          VINVehicle: {
            VINumber: {
              VinCode: {
                Value: 'W1N2539531F895848',
              },
            },
            ManufacturerCarCode: {
              Value: '253953',
            },
          },
        },
        UpperBodies: null,
      },
      SparePartPositions: null,
      Comments: null,
      Attachments: null,
      AdditionalVehicles: null,
      overwrite: false,
    },
  },
};
